import { forwardRef } from "react";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/iconBase.tsx
var iconSizes = {
	xsmall: 16,
	small: 20,
	medium: 24
};
var IconBase = forwardRef(function IconBase({ children, fill = "none", viewBox, "data-testid": testId, size = 18, width, height, ...rest }, ref) {
	const baseSize = typeof size === "number" ? size : iconSizes[size];
	const hasAccessibleText = Boolean(rest["aria-label"] || rest["aria-labelledby"] || rest.role && rest.role !== "presentation" && rest.role !== "none");
	const role = rest.role || (!hasAccessibleText ? "presentation" : void 0);
	return /* @__PURE__ */ jsx("svg", {
		ref,
		xmlns: "http://www.w3.org/2000/svg",
		width: width ?? baseSize,
		height: height ?? baseSize,
		viewBox,
		fill,
		shapeRendering: "geometricPrecision",
		"data-testid": testId,
		css: { flexShrink: 0 },
		role,
		...rest,
		children
	});
});
//#endregion
export { IconBase, iconSizes };
